import { Analytics } from './types'
import { capture, getDistinctId, initialize, isInitialized, optIn, optOut } from './posthog'

const analytics: Analytics = {
  initialize,
  isInitialized,
  optOut,
  optIn,
  getDistinctId,
  donationFlow: {
    donationButtonClicked: (data) => {
      capture('Donation Button Clicked', data)
    },
    donationFormOpened: (data) => {
      capture('Donation Form Opened', data)
    },
    coDonationModalOpened: (data) => {
      capture('Co-Donation Modal Opened', data)
    },
    donationSubmitted: (data) => {
      capture('Donation Submitted', data)
    },
    donationCompleted: (data) => {
      capture('Donation Completed', data)
    },
    donationErrorMessageDisplayed: (data) => {
      capture('Donation Error Message Displayed', data)
    },
  },
}

export default analytics
